import React, {useState} from 'react';
import TogglerBody from '../../../../template/TogglerBody';

const SettingNotification = () => {
    const [isOnUpdates, setIsOnUpdates] = useState(false)
    const [isOnUpdatesDashboard, setIsOnUpdatesDashboard] = useState(false)
    const [isOnErrors, setIsOnErrors] = useState(false)
    const [isOnErrorsDashboard, setIsOnErrorsDashboard] = useState(false)
    const [isOnAdmin, setIsOnAdmin] = useState(false)
    const [isOnAdminDashboard, setIsOnAdminDashboard] = useState(false)
    const [isOnScheduled, setIsOnScheduled] = useState(false)
    const [isOnScheduledDashboard, setIsOnScheduledDashboard] = useState(false)
    return (
        <div className='setting_component_wrap setting_component_wrap_notification'>
            <h3>Notification</h3>
            <div className='setting_component_val_active__item'>
                <p>Email</p>
                <p>Dashboard</p>
            </div>
            <div className='setting_component_content_right_side_item_wrap' >
                <div className='setting_component_content_right_side_item' >
                    <p>Updates</p>
                    <div className='setting_component_content_right_side_item_toggler'>
                        <TogglerBody
                        isOn={isOnUpdates}
                        setIsOn={setIsOnUpdates}
                        />
                        <TogglerBody
                        isOn={isOnUpdatesDashboard}
                        setIsOn={setIsOnUpdatesDashboard}
                        />
                    </div>
                </div>
                <div className='setting_component_content_right_side_item'>
                    <p>Errors</p>
                    <div className='setting_component_content_right_side_item_toggler'>
                        <TogglerBody
                        isOn={isOnErrors}
                        setIsOn={setIsOnErrors}
                        />
                        <TogglerBody
                        isOn={isOnErrorsDashboard}
                        setIsOn={setIsOnErrorsDashboard}
                        />
                    </div>
                </div>
                <div className='setting_component_content_right_side_item'>
                    <p>Admin intervention</p>
                    <div className='setting_component_content_right_side_item_toggler'>
                        <TogglerBody
                        isOn={isOnAdmin}
                        setIsOn={setIsOnAdmin}
                        />
                        <TogglerBody
                        isOn={isOnAdminDashboard}
                        setIsOn={setIsOnAdminDashboard}
                        />
                    </div>
                </div>
                <div className='setting_component_content_right_side_item'>
                    <p>Scheduled Maintenance</p>
                    <div className='setting_component_content_right_side_item_toggler'>
                        <TogglerBody
                        isOn={isOnAdmin}
                        setIsOn={setIsOnAdmin}
                        />
                        <TogglerBody
                        isOn={isOnAdminDashboard}
                        setIsOn={setIsOnAdminDashboard}
                        />
                    </div>
                </div>
            </div>
                <div className='security_component_item_btn'>
                <button className='btn btn_second'>Cancel</button>
                <button className='btn btn_prime'>Save</button>
                </div>
        </div>
    );
};

export default SettingNotification;